import { useMemo, useState } from 'react';
import { timeline } from '@/mocks/chigua';

const FILTERS = ['全部', '娱乐八卦', '影视综艺', '社会热议', '科技圈', '体育竞技', '生活圈'];

export default function Timeline() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? timeline : timeline.filter((t) => t.cat === active)),
    [active],
  );

  return (
    <div>
      {/* filter pills */}
      <div className="flex flex-wrap items-center gap-2">
        {FILTERS.map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => setActive(f)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
              active === f
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {/* feed */}
      <div className="mt-5 space-y-4">
        {list.map((it) => (
          <article
            key={it.id}
            className="relative overflow-hidden rounded-lg border border-secondary-100 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5"
          >
            <span className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-primary-400 to-accent-500"></span>
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                {it.cat}
              </span>
              <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                <i className="ri-time-line"></i> {it.time}
              </span>
              {it.tag && (
                <span
                  className={`flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-semibold ${
                    it.tag === '爆'
                      ? 'bg-primary-100 text-primary-800'
                      : it.tag === '热'
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {it.tag === '爆' ? <i className="ri-fire-fill"></i> : <i className="ri-flashlight-fill"></i>}
                  {it.tag}
                </span>
              )}
            </div>

            <h3 className="heading-font mt-2 text-base font-bold leading-snug text-foreground-950 md:text-lg">
              <a href="#ts" className="transition-colors hover:text-primary-600">
                {it.title}
              </a>
            </h3>
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{it.summary}</p>

            <div className="mt-3 flex flex-wrap items-center justify-between gap-3 border-t border-secondary-100 pt-3">
              <div className="flex items-center gap-2">
                <span className="h-1.5 w-24 overflow-hidden rounded-full bg-secondary-100">
                  <span
                    className="block h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                    style={{ width: `${it.heat}%` }}
                  ></span>
                </span>
                <span className="text-[11px] text-foreground-500">热度 {it.heat}%</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                  <i className="ri-chat-3-line text-primary-500"></i> {it.discuss} 参与
                </span>
                <a
                  href="#huati"
                  className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
                >
                  进入讨论 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>
        ))}

        {list.length === 0 && (
          <div className="rounded-lg border border-secondary-100 bg-background-50 p-8 text-center text-sm text-foreground-500">
            当前栏目下暂无速览，去看看其他分类吧。
          </div>
        )}
      </div>
    </div>
  );
}